import { Contract } from "ethers";
import { ethers } from "ethers";

import toast from "react-hot-toast";
import {
  SFM_WEAPON_CONTRACT_ADDRESS,
  SFM_WEAPON_CONTRACT_ABI,
} from "./SFM-WeaponConstants";

// Connect to the Base Sepolia testnet
// const provider = new ethers.providers.BaseSepoliaProvider();
// const signer = provider.getSigner();

export async function mintWeapon(nft) {
  // Get the Metamask provider
  const provider = new ethers.providers.Web3Provider(window.ethereum);
  const chainID = (await provider.getNetwork()).chainId;
  if (chainID === 84532) {
    const signer = provider.getSigner();
    const address = await signer.getAddress();
    // Connect to the Contract
    const contract = new Contract(
      SFM_WEAPON_CONTRACT_ADDRESS,
      SFM_WEAPON_CONTRACT_ABI,
      signer
    );

    try {
      const tx = await contract.safeMint(
        address,
        nft.uri,
        nft.name,
        nft.image,
        nft.sprite_photo,
        nft.level,
        nft.speed,
        nft.sound,
        nft.class,
        nft.ammo
      );
      toast.promise(tx.wait(), {
        loading: "Buying NFT",
        success: displayMessageWithLink(tx.hash),
        error: "Buying failed",
      });
    } catch (e) {
      toast.error("Buying failed");
    }
  } else {
    toast.error("Please connect to Base Sepolia Testnet");
  }
}

export const getWeapons = async () => {
  const provider = new ethers.providers.Web3Provider(window.ethereum);
  const chainID = (await provider.getNetwork()).chainId;
  if (chainID === 84532) {
    const signer = provider.getSigner();
    const address = await signer.getAddress();
    // Connect to the Contract
    const contract = new Contract(
      SFM_WEAPON_CONTRACT_ADDRESS,
      SFM_WEAPON_CONTRACT_ABI,
      signer
    );

    const nfts = await contract.getNftsbyOwner(address);

    return nfts;
  } else {
    toast.error("Please connect to Base Sepolia Testnet");
  }
};

const displayMessageWithLink = (hash) => (
  <div>
    Buying success! for transaction{" "}
    <a
      href={`https://sepolia.basescan.org/tx/${hash}`}
      target="_blank"
      rel="noreferrer"
    >
      Click Here
    </a>
  </div>
);
